module.exports = __webpack_public_path__ + "img/SI5092221.a152dd4b.jpeg";